import { EventRepository } from '~repositories/EventRepository';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';
import { IStoreDeliveryMethodsData } from '~interfaces/IAnalytics';

export class StoreDeliveryMethodsUseCase {
    private eventRepository: EventRepository;
    private storeDeliveryMethodsData: IStoreDeliveryMethodsData;
    private eventName: string;

    constructor(storeDeliveryMethodsData: IStoreDeliveryMethodsData, eventName: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.storeDeliveryMethodsData = storeDeliveryMethodsData;
        this.eventName = eventName;
    }

    public execute = async () => {
        const { eventAction, eventLabel, eventName, eventCategory } = this.storeDeliveryMethodsData;
        const payload = {
            event_name: eventName || 'store_delivery_type',
            event_category: eventCategory || 'ecommerce',
            event_action: eventAction,
            event_label: eventLabel
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: this.eventName,
            type: 'link',
            payload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
